import React from 'react';
import './styles.scss';
import { IconName } from '@/types';
import { useConfigStore } from '@/hooks/stores';
import { useCustomComponent } from '@/hooks';
import Components from './components';

export interface ActionCardProps {
  index?: number;
  title: string;
  description: string;
  icon: IconName;
  url?: string;
  onClick?: () => void;
}

const ActionCardComponent: React.FC<ActionCardProps> = ({
  index,
  title,
  description,
  icon,
  url,
  onClick,
}) => {
  const {
    theme: { colors },
  } = useConfigStore();

  return (
    <Components.Root
      className="peptalk-action-card"
      style={{ animationDelay: `${0.25 + (index ? index * 0.1 : 0)}s` }}
      onClick={
        url ? () => window.open(url, '_blank', 'noopener,noreferrer') : onClick
      }
    >
      <Components.Content>
        <Components.Title>{title}</Components.Title>
        <Components.Description>{description}</Components.Description>
      </Components.Content>
      <Components.Icon name={icon} color={colors.primary} />
    </Components.Root>
  );
};

export const ActionCard: React.FC<ActionCardProps> = (
  props: ActionCardProps
) => {
  const Component = useCustomComponent({
    componentName: 'ActionCard',
    Component: ActionCardComponent,
  });

  return <Component {...props} />;
};
